module.exports = __webpack_public_path__ + "media/images/front/carton_verde-93372dd3c02a460aad5fdea522422aba.jpg";